module.exports = __webpack_public_path__ + "img/katarina6.a311eb71.jpg";